<template>
  <div class="flex flex-col space-y-5">
    <div class="space-x-5">
      <my-button :disabled="isNaN(id)" icon="printer" type="primary" @click="handlePrint">Гэрээ хэвлэх</my-button>
      <my-button :disabled="isNaN(id)" icon="cash" type="primary" @click="handlePayment">Төлбөр бүртгэх</my-button>
      <my-button :disabled="isNaN(id) || (contract && !contract.treatment)" icon="clock" type="primary" @click="handlePostpone">Хойшлуулах</my-button>
      <my-button icon="check" type="success" @click="handleSave" :loading="saving">Хадгалах</my-button>
      <my-button icon="x" @click="handleBack">Буцах</my-button>
    </div>
    <div v-if="loading">
      <my-alert>Та түр хүлээнэ үү..</my-alert>
    </div>
    <div v-else-if="error">
      <my-alert type="error">{{ error }}</my-alert>
    </div>
    <div v-else-if="contract" class="flex flex-col space-y-5">
      <div class="space-x-5 flex flex-row">
        <my-panel title="Үйлчүүлэгчийн мэдээлэл" label-position="left" label-width="150px">
          <!-- @change="handleEnterCustomer" -->
          <my-input
            v-model="customer.registerNum"
            trim
            :required="isRequired('checkCustomer.registerNum')"
            label="Регистрийн дугаар"
            :readonly="loadingCustomer"
            :error="errors.includes('registerNum')">
            <my-button :loading="loadingCustomer" type="ghost" icon="search" square @click="handleSearchCustomer"></my-button>
          </my-input>
          <my-input v-model="customer.lastName" label="Овог" :error="errors.includes('lastName')" :required="isRequired('checkCustomer.lastName')"></my-input>
          <my-input v-model="customer.firstName" label="Нэр" :error="errors.includes('firstName')" :required="isRequired('checkCustomer.firstName')"></my-input>
          <my-select v-model="customer.birthAimagCity" label="Аймаг" :options="aimagCities" @change="handleChangeAimag" :error="errors.includes('birthAimagCity')" :required="isRequired('checkCustomer.birthAimagCity')"></my-select>
          <my-select v-model="customer.birthSoumDistrict" label="Сум" :options="soumDistricts" :error="errors.includes('birthSoumDistrict')" :required="isRequired('checkCustomer.birthSoumDistrict')"></my-select>
        </my-panel>
        <my-panel title="Төлөөлөх хүн" label-position="left" label-width="150px">
          <!-- @change="handleSearchCustomer1" -->
          <my-input
            v-model="representCustomer.registerNum"
            label="Регистрийн дугаар"
            :required="isRequired('checkCustomer1.registerNum')"
            :readonly="loadingCustomer1"
            trim
            :error="errors.includes('registerNum1')">
            <my-button :loading="loadingCustomer1" type="ghost" icon="search" square @click="handleSearchCustomer1"></my-button>
          </my-input>
          <my-input v-model="representCustomer.lastName" label="Овог" :error="errors.includes('lastName1')" :required="isRequired('checkCustomer1.lastName')"></my-input>
          <my-input v-model="representCustomer.firstName" label="Нэр" :error="errors.includes('firstName1')" :required="isRequired('checkCustomer1.firstName')"></my-input>
          <my-select v-model="representCustomer.birthAimagCity" label="Аймаг" :options="aimagCities" @change="handleChangeRAimag" :required="isRequired('checkCustomer1.birthAimagCity')"></my-select>
          <my-select v-model="representCustomer.birthSoumDistrict" label="Сум" :options="rSoumDistricts" :required="isRequired('checkCustomer1.birthSoumDistrict')"></my-select>
        </my-panel>
      </div>
      <div class="space-x-5 flex flex-row">
        <my-panel title="Гэрээний мэдээлэл" label-position="left" label-width="150px">
          <my-input v-model="contract.regNo" label="Гэрээний дугаар" :error="errors.includes('regNo')" :required="isRequired('checkContract.regNo')"></my-input>
          <my-select v-model="contract.verification" label="Магадлагааны жил" :options="verifications" :error="errors.includes('verification')" :required="isRequired('checkContract.verification')"></my-select>
          <my-select v-model="contract.treatment" label="Эмчилгээний он, сар" placeholder="Хойшлуулсан" @change="handleChangeTreatment" :options="treatments" labelKey='treatmentAt' :error="errors.includes('treatment')" :required="isRequired('checkContract.treatmentAt')"></my-select>
          <my-select-list v-model="contract.treatmentDay" label="Эмчилгээний өдөр, цаг" :options="treatmentDays" :required="isRequired('checkContract.treatmentDay')"></my-select-list>
          <my-select v-model="contract.status" readonly disabled label="Төлөв" :options="statuses" :required="isRequired('checkContract.status')"></my-select>
        </my-panel>
        <my-panel title="Утасны дугаар" label-position="left" label-width="150px">
          <template v-slot:actions>
            <div class="space-x-1">
              <my-button v-if="mobiles.length > 3" square size="small" icon="minus" type="ghost" @click="handleRemoveMobile"></my-button>
              <my-button square size="small" icon="plus" type="ghost" @click="handleAddMobile"></my-button>
            </div>
          </template>
          <template v-for="(item, index) in mobiles" :key="index">
            <my-input
              v-model="item.phoneNumber"
              mask="####-####"
              :label="`Дугаар ${index + 1}`"
              :error="errors.includes('phoneNumber' + index)"
              :required="isRequired('checkMobile.phoneNumber')"
              @change="handleCheckProblem(item.phoneNumber)">
              <my-select v-model="item.relationType" class="w-32" :options="relationTypes" :error="errors.includes('relationType' + index)"/>
              <label class="swap">
                <input type="checkbox" :checked="item.isWrong" @input="handleChangeWrong($event, item)" />
                <span class="swap-on">
                  <hero-icon color="text-yellow-600" :name="`exclamation-circle`" />
                </span>
                <span class="swap-off">
                  <hero-icon :name="`check-circle`" />
                </span>
              </label>
            </my-input>
          </template>
        </my-panel>
      </div>
      <div class="space-x-5 flex flex-row">
        <my-panel title="Явцын тэмдэглэл" label-position="left" label-width="150px">
          <template v-slot:actions>
            <div v-if="!isNaN(id)" class="space-x-2">
              <my-button square size="small" icon="view-list" type="ghost" @click="handleListCustomerNote"></my-button>
              <my-button square size="small" icon="plus" type="ghost" @click="handleAddCustomerNote"></my-button>
            </div>
          </template>
          <my-alert v-if="customerNote.isProblem" type="error">Асуудалтай</my-alert>
          <my-alert v-else type="success">Асуудалгүй</my-alert>
          <my-input label="Уусан эсэх?" readonly type="checkbox" v-model="customerNote.isDrunk"></my-input>
          <my-input v-model="customerNote.note" label="Тэмдэглэл" type="textarea" :readonly="!isNaN(id)" rows="5"></my-input>
        </my-panel>
        <my-panel title="Төлбөр" label-position="left" label-width="150px">
          <template v-if="!isNaN(id) && contract" v-slot:actions>
            <div v-if="contract.status.code !== '2'" class="space-x-2">
              <my-button :loading="loadingPayment" size="small" icon="cash" type="primary" @click="handlePayment">Төлөх</my-button>
              <my-button :loading="loadingCancel" size="small" icon="x" type="warning" @click="handleCancel">Цуцлах</my-button>
            </div>
            <div v-else>
              <my-button :loading="loadingCancelBack" size="small" icon="x" type="error" @click="handleCancelBack">Цуцлалт буцаах</my-button>
            </div>
          </template>
          <my-input v-model.number="contract.amount" label="Эмчилгээний үнэ" readonly currency></my-input>
          <my-input v-model.number="contract.discount" label="Хөнгөлөлт" currency :error="errors.includes('discount')"></my-input>
          <my-input v-model.number="contract.paid" label="Төлсөн" currency :readonly="!isNaN(id)" :error="errors.includes('paid')"></my-input>
          <my-select v-model="contract.cashe" label="Төлсөн хэлбэр" :options="paymentCashes" :error="errors.includes('cashe')"/>
          <my-input label="Төлсөн огноо/сүүлд/" v-model="contract.paidAt" mask="####-##-##" placeholder="ЖЖЖЖ-СС-ӨӨ" :error="errors.includes('paidAt')"></my-input>
        </my-panel>
      </div>
    </div>
    <customer-note-list v-model:contract-id="customerNoteListId"></customer-note-list>
    <customer-note-create
      v-model:contract-id="customerNoteCreateId"
      @saveCustomerNote="handleSaveCustomerNote"
      :customerNote="customerNote"
      >
    </customer-note-create>
    <customerProblem v-model:data="customerProblemData" />
  </div>
</template>
<script>
import customerNoteMethods from './methods/customerNote'
import { regexpRegisterNum, regexpName, regexpMobile, regexpAscii } from '../../utils/regexps'
import { numberToWord } from '../../utils/helper'
import customerNoteList from '../../components/contract/customerNoteList.vue'
import customerNoteCreate from '../../components/contract/customerNoteCreate.vue'
import customerProblem from '../../components/contract/customerProblem.vue'
import _ from 'lodash'
export default {
  components: {
    customerProblem,
    customerNoteList,
    customerNoteCreate
  },
  data () {
    return {
      loading: false,
      loadingPayment: false,
      loadingCancel: false,
      loadingCancelBack: false,
      loadingCustomer: false,
      loadingCustomer1: false,
      customerNoteListId: null,
      customerNoteCreateId: null,
      saving: false,
      error: '',
      errors: [],
      relationTypes: [],
      paymentCashes: [],
      aimagCities: [],
      treatments: [],
      soumDistricts: [],
      rSoumDistricts: [],
      verifications: [],
      statuses: [],
      currentAmount: 0,
      tCustomer: {
        registerNum: '',
        lastName: '',
        firstName: '',
        birthAimagCity: null,
        birthSoumDistrict: null
      },
      checkCustomer: {
        registerNum: { required: true, regexp: regexpRegisterNum },
        lastName: { required: true, regexp: regexpName },
        firstName: { required: true, regexp: regexpName },
        birthAimagCity: { required: true },
        birthSoumDistrict: { required: true }
      },
      checkCustomer1: {
        registerNum: { required: false, regexp: regexpRegisterNum },
        lastName: { required: false, regexp: regexpName },
        firstName: { required: false, regexp: regexpName }
      },
      checkContract: {
        regNo: { required: true, regexp: regexpAscii },
        treatment: { required: false },
        verification: { required: false }
      },
      checkMobile: {
        phoneNumber: { required: true, regexp: regexpMobile },
        relationType: { required: true }
      },
      tContract: {
        id: null,
        regNo: '',
        treatment: null,
        treatmentDay: null,
        verification: null,
        amount: 0,
        discount: 0,
        paid: 0
      },
      tCustomerNote: {
        id: null,
        isProblem: false,
        isDrunk: false,
        note: ''
      },
      tMobiles: [{
        id: null,
        phoneNumber: '',
        relationType: null
      }, {
        id: null,
        phoneNumber: '',
        relationType: null
      }, {
        id: null,
        phoneNumber: '',
        relationType: null
      }],
      customer: null,
      contract: null,
      mobiles: [],
      representCustomer: null,
      customerNote: null,
      printText: '',
      customerProblemData: [[], 0]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    customerId () {
      return this.$route.query.id
    },
    treatmentDays () {
      return this.contract && this.contract.treatment && this.contract.treatment.treatmentDays ? this.contract.treatment.treatmentDays.split(',').map(c => { return c.trim() }) : []
    }
  },
  watch: {
    id () {
      this.handleRefresh()
    },
    customerId (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  created () {
    this.handleRefresh()
    window.document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.keyCode === 83) {
        this.handleSave()
        e.preventDefault()
      }
    })
  },
  methods: {
    ...customerNoteMethods,
    handleChangeWrong ($event, item) {
      console.log('$event.target.checked', $event.target.checked)
      item.isWrong = $event.target.checked
    },
    isRequired (name) {
      return _.get(this, name + '.required')
    },
    handleBack () {
      this.$router.go(-1)
    },
    isNaN (val) {
      return isNaN(val)
    },
    reset () {
      this.customer = Object.assign({}, this.tCustomer)
      this.representCustomer = Object.assign({}, this.tCustomer)
      this.mobiles = [...this.tMobiles]
      this.customerNote = Object.assign({}, this.tCustomerNote)
      this.contract = Object.assign({}, this.tContract, {
        amount: this.currentAmount,
        status: this.statuses[0],
        treatment: this.treatments[0],
        cashe: { id: 1 },
        paidAt: this.moment().format('YYYY-MM-DD')
      })
    },
    async handleRefresh () {
      try {
        this.errors = []
        this.error = ''
        this.loading = true
        await this.getLookups()
        this.reset()
        if (!this.isNaN(this.customerId)) {
          this.customer = await this.getCustomerId(this.customerId)
        } else if (!this.isNaN(this.id)) {
          this.contract = (await this.axios.get(`contracts/${this.id}`)).data
          if (!this.contract) {
            this.customError('Бүртгэлийн мэдээлэл буруу эсвэл устсан байна.')
          }
          this.customer = await this.getCustomerId(this.contract.customer.id)
          if (this.contract.representCustomer) {
            this.representCustomer = await this.getCustomerId(this.contract.representCustomer.id)
            if (this.representCustomer.birthAimagCity) {
              this.rSoumDistricts = await this.getSoumDistrict(this.representCustomer.birthAimagCity.id)
            }
          }
          const dNote = (await this.axios.get(`contracts/customerNote/${this.contract.id}`)).data
          if (dNote) {
            this.customerNote = dNote
          }
        }
        if (this.customer) {
          this.mobiles = await this.getCustomerMobiles(this.customer.id)
          if (this.customer && this.customer.birthAimagCity) {
            this.soumDistricts = await this.getSoumDistrict(this.customer.birthAimagCity.id)
          }
        }
        if (!this.mobiles || this.mobiles.length === 0) {
          this.mobiles = [...this.tMobiles]
        }
      } catch (err) {
        this.error = this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    resetErrors () {
      this.errors = []
    },
    resetError (keyName) {
      const index = this.errors.indexOf(keyName)
      if (index !== -1) {
        this.errors.splice(index, 1)
      }
    },
    setError (keyName) {
      if (!this.errors.includes(keyName)) {
        this.errors.push(keyName)
      }
    },
    async getCustomerId (id) {
      return (await this.axios.get('customers/one', { params: { search: [{ name: 'id', value: id }] } })).data
    },
    async getCustomer (registerNum) {
      if (!registerNum || !regexpRegisterNum.test(registerNum)) {
        this.customError('Регистрийн дугаар буруу байна.')
      }
      return (await this.axios.get('customers/one', { params: { search: [{ name: 'registerNum', value: registerNum }] } })).data
    },
    async getCustomerMobiles (customerId) {
      return (await this.axios.get(`contracts/mobiles/${customerId}`)).data
    },
    async handlePrint () {
      try {
        let printHtml = (await this.axios.get('contracts/certificate/pdf')).data
        printHtml = printHtml.replace('{date}', this.moment(this.contract.createdAt).format('YYYY оны MM сарын DD ны өдөр'))
        printHtml = printHtml.replace('{regNo}', this.contract.regNo)
        printHtml = printHtml.replace('{rd}', this.customer.registerNum)
        printHtml = printHtml.replace('{firstname}', this.customer.firstName)
        printHtml = printHtml.replace('{lastname}', this.customer.lastName)
        let customer1Html = ''
        if (this.representCustomer && this.representCustomer.registerNum) {
          customer1Html = `/, &#1090;&#1199;&#1199;&#1085;&#1080;&#1081;&#1075;
      &#1090;&#1257;&#1083;&#1257;&#1257;&#1083;&#1078; </span><span class="c7">{rd1}</span><span
      class="c13">&#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1081;&#1085;
      &#1076;&#1091;&#1075;&#1072;&#1072;&#1088;&#1090;&#1072;&#1081; &nbsp;</span><span
      class="c7">{firstname1}</span><span class="c13">/`
          customer1Html = customer1Html.replace('{rd1}', this.representCustomer ? this.representCustomer.registerNum : '-')
          customer1Html = customer1Html.replace('{firstname1}', this.representCustomer ? this.representCustomer.lastName.slice(0, 1) + '.' + this.representCustomer.firstName : '-')
        }
        printHtml = printHtml.replace('{customer1}', customer1Html)
        if (this.customer.birthAimagCity) {
          let address = this.customer.birthAimagCity.name
          let soumPrefix = ' сум'
          if (this.customer.birthAimagCity.code === '11') {
            address += ' хот'
            soumPrefix = ' дүүрэг'
          } else {
            address += ' аймаг'
          }
          if (this.customer.birthSoumDistrict) {
            address += ', ' + this.customer.birthSoumDistrict.name + soumPrefix
          }
          printHtml = printHtml.replace('{address}', address)
        } else {
          printHtml = printHtml.replace('{address}', '-')
        }
        printHtml = printHtml.replace('{aimag}', this.customer.birthAimagCity ? this.customer.birthAimagCity.name : '-')
        printHtml = printHtml.replace('{soum}', this.customer.birthSoumDistrict ? this.customer.birthSoumDistrict.name : '-')
        printHtml = printHtml.replace('{regNo}', this.contract.regNo)
        const amount = this.contract.amount - this.contract.discount
        const balance = amount - this.contract.paid
        printHtml = printHtml.replace('{amount}', String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        printHtml = printHtml.replace('{amountstr}', numberToWord(amount))
        printHtml = printHtml.replace('{paid}', String(this.contract.paid).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        printHtml = printHtml.replace('{paidstr}', numberToWord(this.contract.paid))
        printHtml = printHtml.replace('{balance}', String(balance).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        printHtml = printHtml.replace('{balancestr}', numberToWord(balance))
        const phone1 = `${_.get(this.mobiles, '[0].phoneNumber') || ''}/${_.get(this.mobiles, '[0].relationType.name') || ''}`
        const phone2 = `${_.get(this.mobiles, '[1].phoneNumber') || ''}/${_.get(this.mobiles, '[1].relationType.name') || ''}`
        const phone3 = `${_.get(this.mobiles, '[2].phoneNumber') || ''}/${_.get(this.mobiles, '[2].relationType.name') || ''}`
        printHtml = printHtml.replace('{phone1}', phone1 || '')
        printHtml = printHtml.replace('{phone2}', phone2 || '')
        printHtml = printHtml.replace('{phone3}', phone3 || '')
        const newWin = window.open('Гэрээ хэвлэх', 'Print-Window')
        newWin.document.open()
        newWin.document.write(printHtml)
        newWin.focus()
        newWin.print()
        newWin.close()
        // setTimeout(function () { newWin.close() }, 10)
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleEnterCustomer () {
      try {
        this.resetError('registerNum')
        this.loadingCustomer = true
        this.customer = Object.assign({}, this.tCustomer, { registerNum: this.customer.registerNum })
        const data = await this.getCustomer(this.customer.registerNum)
        if (!data) {
          this.customError('Үйлчлүүлэгийн мэдээлэл олсонгүй.')
        }
        this.customer = data
        this.mobiles = await this.getCustomerMobiles(data.id)
        if (this.customer && this.customer.birthAimagCity) {
          this.soumDistricts = await this.getSoumDistrict(this.customer.birthAimagCity.id)
        }
      } catch (err) {
        this.handleError(err)
        this.setError('registerNum')
      } finally {
        this.loadingCustomer = false
      }
    },
    async handleSearchCustomer () {
      try {
        this.resetError('registerNum')
        this.reset()
        // this.customer = Object.assign({}, this.tCustomer, { registerNum: this.customer.registerNum })
        this.customer = await this.searchCustomerContracts(this.customer.registerNum)
        if (this.customer && this.customer.birthAimagCity) {
          this.soumDistricts = await this.getSoumDistrict(this.customer.birthAimagCity.id)
        }
        this.mobiles = await this.getCustomerMobiles(this.customer.id)
      } catch (err) {
        const error = this.handleError(err)
        if (!error) {
          this.setError('registerNum')
        }
      }
    },
    async handleSearchCustomer1 () {
      try {
        this.resetError('registerNum1')
        this.loadingCustomer1 = true
        this.representCustomer = Object.assign({}, this.tCustomer, { registerNum: this.representCustomer.registerNum })
        const data = await this.getCustomer(this.representCustomer.registerNum)
        if (!data) {
          this.customError('Үйлчлүүлэгийн мэдээлэл олсонгүй.')
        }
        this.representCustomer = data
        if (this.representCustomer && this.representCustomer.birthAimagCity) {
          this.rSoumDistricts = await this.getSoumDistrict(this.representCustomer.birthAimagCity.id)
        }
      } catch (err) {
        this.handleError(err)
        this.setError('registerNum1')
      } finally {
        this.loadingCustomer1 = false
      }
    },
    handleAddMobile () {
      this.mobiles.push({ phoneNumber: '', relationTypeId: null, isWrong: false })
    },
    handleRemoveMobile () {
      this.mobiles.splice(this.mobiles.length - 1, 1)
    },
    async getLookups () {
      this.currentAmount = (await this.axios.get('lookups/current/amount')).data
      this.relationTypes = (await this.axios.get('lookups/relation_types')).data
      this.paymentCashes = (await this.axios.get('lookups/payment_cashes')).data
      this.aimagCities = (await this.axios.get('lookups/aimag_cities')).data
      this.treatments = (await this.axios.get('lookups/treatments', { params: { selectStr: 'id, treatmentAt, treatmentDays, note', orderStr: 'treatmentAt DESC' } })).data
      this.verifications = (await this.axios.get('lookups/verifications')).data
      this.statuses = (await this.axios.get('lookups/contract_status', { params: { selectStr: 'id, color, name, code' } })).data
    },
    async getSoumDistrict (aimagCityId) {
      return (await this.axios.get('lookups/soum_districts', { params: { whereStr: `aimagCityId=${aimagCityId}` } })).data
    },
    handleChangeTreatment () {
      this.contract.treatmentDay = null
    },
    async handleChangeAimag ($event) {
      try {
        this.soumDistricts = await this.getSoumDistrict($event.target.value)
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleChangeRAimag ($event) {
      try {
        this.rSoumDistricts = await this.getSoumDistrict($event.target.value)
      } catch (err) {
        this.handleError(err)
      }
    },
    async handlePayment () {
      try {
        this.loadingPayment = true
        const data = await this.showConfirm({
          title: 'Төлбөр төлөх',
          currency: true,
          isCashe: true,
          btnTextYes: 'Хадгалах',
          btnTextNo: 'Буцах',
          noClose: true
        })
        await this.axios.post('contracts/payment', Object.assign({
          contract: this.id
        }, data))
        this.contract.paid += data.value
        this.contract.paidAt = data.paidAt
        this.contract.cashe = data.cashe
        this.showToast('Амжилттай төлбөр бүртгэлээ.')
        this.hideConfirm()
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loadingPayment = false
      }
    },
    async handlePostpone () {
      try {
        await this.showConfirm({
          message: 'Та эмчилгээг хойшлуулахдаа итгэлтэй байна уу?'
        })
        await this.axios.post('contracts/postpone', { contractId: this.id })
        this.showToast('Амжилттай хойшлууллаа.')
        this.contract.treatment = null
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleCancel () {
      try {
        this.loadingCancel = true
        const data = await this.showConfirm({
          title: 'Гэрээ цуцлах',
          message: 'Та буцаан олгож байгаа мөнгөн дүнг оруулна уу!.',
          currency: true,
          btnTextYes: 'Хадгалах',
          btnTextNo: 'Буцах',
          isCancelType: true
        })
        await this.axios.post('contracts/cancel', Object.assign({
          contract: this.id
        }, data))
        this.contract.paid -= data.value
        this.contract.status = this.statuses.find(c => c.code === '2')
        this.showToast('Амжилттай цуцаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loadingCancel = false
      }
    },
    async handleCancelBack () {
      try {
        if (this.loadingCancelBack) {
          return
        }
        this.loadingCancelBack = true
        await this.showConfirm({
          message: 'Та цуцалсан үйлдлээ буцаахдаа итгэлтэй байна уу?'
        })
        const { paid, paidAt, status } = (await this.axios.post('contracts/cancelBack', {
          contractId: this.id
        })).data
        this.contract.paid = paid
        this.contract.paidAt = paidAt
        this.contract.status = status
        this.showToast('Амжилттай цуцлалтыг буцаалаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loadingCancelBack = false
      }
    },
    async handleSave () {
      try {
        if (this.saving) {
          return
        }
        this.saving = true
        this.checkData()
        const data = (await this.axios.post('contracts', {
          contract: this.contract,
          customer: this.customer,
          representCustomer: this.representCustomer,
          mobiles: this.mobiles,
          customerNote: this.customerNote
        })).data
        this.showToast('Амжилттай хадгаллаа.')
        if (this.isNaN(this.id)) {
          this.$router.push({ name: 'contracts-detail', params: { id: data } })
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    },
    checkData () {
      this.resetErrors()
      for (const key in this.checkCustomer) {
        const check = this.checkCustomer[key]
        if (check.required && !this.customer[key]) {
          this.setError(key)
        }
        if (this.customer[key] && check.regexp && !check.regexp.test(this.customer[key])) {
          this.setError(key)
        }
      }
      for (const key in this.checkCustomer1) {
        const check = this.checkCustomer1[key]
        if (check.required && !this.representCustomer[key]) {
          this.setError(key + '1')
        }
        if (this.representCustomer[key] && check.regexp && !check.regexp.test(this.representCustomer[key])) {
          this.setError(key + '1')
        }
      }
      for (const key in this.checkContract) {
        const check = this.checkContract[key]
        if (check.required && !this.contract[key]) {
          this.setError(key)
        }
        if (this.contract[key] && check.regexp && !check.regexp.test(this.contract[key])) {
          this.setError(key)
        }
      }
      if (this.contract.discount > 0 && this.contract.discount > this.contract.amount) {
        this.setError('discount')
      }
      if (this.contract.paid > 0 && this.contract.paid > (this.contract.amount - this.contract.discount)) {
        this.setError('paid')
      }
      if (this.customer.registerNum === this.representCustomer.registerNum) {
        this.setError('registerNum1')
      }
      this.mobiles.map((mobile, index) => {
        for (const key in this.checkMobile) {
          const check = this.checkMobile[key]
          if (check.required && !mobile[key]) {
            this.setError(key + index)
          }
          if (!mobile.isWrong && check.regexp && !check.regexp.test(mobile[key])) {
            this.setError(key + index)
          }
        }
      })
      if (this.errors.length > 0) {
        this.customError('Талбаруудыг гүйцэт бөглөнө үү.')
      }
    },
    async handleCheckProblem (value) {
      try {
        this.customerProblemData = (await this.axios.get('contracts', { params: { name: 'all', limit: 1, page: 1, search: [{ name: 'phoneNumber', value }, { name: 'customer.isProblem', value: '1' }] } })).data
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
